import styled from 'react-emotion';
import { theme } from '@ublend-npm/aulaui-next';

export const NoNotification = styled('div')`
  font-size: 14px;
  text-align: center;
`;

export const NoNotificationImage = styled('img')`
  width: 240px;
  display: block;
  margin: 56px auto 24px;
`;

export const NoNotificationText = styled('span')`
  font-family: ${theme.font.family.workSans};
  font-weight: 700;
  font-size: 15px;
  color: ${theme.color.black};
  line-height: 25px;
`;

export const styles = {
  table: {
    maxWidth: 900,
    minWidth: 450,
    paddingRight: 28,
    paddingLeft: 28,
    paddingTop: 20,
  },
};
